module.exports = __webpack_public_path__ + "img/ctlogo.931a7648.png";